// ABOUTME: Provides the i18next instance to the React tree and holds rendering until the first
// ABOUTME: language has loaded (translations are fetched on demand, see ./i18n.ts). Mounted once in src/index.tsx.

import { type FC, type ReactNode, Suspense, use } from "react"
import { I18nextProvider } from "react-i18next"
import i18n, { i18nReady } from "./i18n"

interface LanguageProviderProps {
  children: ReactNode
}

// `use` suspends until the promise settles; it is module-level, so React sees the same promise every render.
// Nothing is painted meanwhile — index.html's boot screen stays up until AppShell reports the first render.
const WhenTranslationsLoaded: FC<LanguageProviderProps> = ({ children }) => {
  use(i18nReady)
  return children
}

export const LanguageProvider: FC<LanguageProviderProps> = ({ children }) => {
  return (
    <I18nextProvider i18n={i18n}>
      <Suspense fallback={null}>
        <WhenTranslationsLoaded>{children}</WhenTranslationsLoaded>
      </Suspense>
    </I18nextProvider>
  )
}
